import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoginModule } from '@shared/components/login/login.module';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { UserActionComponent } from './layout/user-actions/user-action.component';

const COMPONENTS = [
	HeaderComponent,
	FooterComponent,
	UserActionComponent
];

const MODULES = [
	CommonModule,
	RouterModule,
	LoginModule
];

@NgModule({
	declarations: [...COMPONENTS],
	imports: [...MODULES],
	exports: [...COMPONENTS]
})
export class CoreModule { }
